import { styled } from '@sans-souci/styles'
import { FC, PropsWithChildren } from 'react'

import { AccordionHeaderDefault } from './AccordionHeaderDefault'
import { useHeightAnimation } from '../helpers/useHeightAnimation'

const Button = styled('button', {
  width: '100%',
  background: 'none',
  margin: '$0',
  padding: '$0',
  color: 'unset',
  border: 'none',
  '-webkit-tap-highlight-color': 'transparent',
  focusStyle: 'default',
})

export type AccordionHeaderType = 'default'

export type AccordionItemProps = {
  itemId?: number
  isActive?: boolean
  className?: string
  onRequestOpen?: (index: number) => void
  onRequestClose?: (index: number) => void
  label: string
  headerType?: AccordionHeaderType
  headerComponent?: FC<{ isActive: boolean }>
}

export const AccordionItem: FC<PropsWithChildren<AccordionItemProps>> = ({
  itemId,
  isActive = false,
  headerType = 'default',
  onRequestClose,
  onRequestOpen,
  label,
  className,
  children,
  headerComponent: HeaderComponent,
}) => {
  const handleClick = () => {
    if (onRequestClose && onRequestOpen && itemId !== undefined) {
      isActive ? onRequestClose(itemId) : onRequestOpen(itemId)
    }
  }

  const Header = (() => {
    switch (headerType) {
      case 'default':
      default:
        return AccordionHeaderDefault
    }
  })()

  const [bodyRef, styles] = useHeightAnimation<HTMLDivElement>({
    isActive,
  })

  return (
    <>
      <Button
        onClick={handleClick}
        aria-expanded={isActive}
        aria-controls={`sect${itemId}`}
        id={`accordion-${itemId}`}
        aria-disabled={isActive}
      >
        {HeaderComponent ? (
          <HeaderComponent isActive={isActive} />
        ) : (
          <Header isActive={isActive}>{label || ''}</Header>
        )}{' '}
      </Button>
      <div
        className={className}
        role="region"
        ref={bodyRef}
        style={styles}
        id={`sect${itemId}`}
        aria-labelledby={`accordion-${itemId}`}
      >
        {children}
      </div>
    </>
  )
}
